export function resetTransform(ctx) {
    if (ctx.resetTransform) {
        ctx.resetTransform();
    }
    else {
        ctx.setTransform(1, 0, 0, 1, 0, 0);
    }
}
export function setLineWidth(ctx, lineWidth) {
    if (!ctx.setLineWidth) {
        ctx.lineWidth = lineWidth;
    }
    else {
        ctx.setLineWidth(lineWidth);
    }
}
export function setFillStyle(ctx, fill) {
    if (!ctx.setFillStyle) {
        ctx.fillStyle = fill;
    }
    else {
        ctx.setFillStyle(fill);
    }
}
export function setFontStyle(ctx, fontSize, fontFamily, fontWeight, fontStyle) {
    if (fontSize === void 0) { fontSize = 12; }
    if (fontFamily === void 0) { fontFamily = 'sans-serif'; }
    if (fontWeight === void 0) { fontWeight = 'normal'; }
    if (fontStyle === void 0) { fontStyle = 'normal'; }
    if (!ctx.setFontSize) {
        ctx.font = fontStyle + " " + fontWeight + " " + fontSize + "px " + fontFamily;
    }
    else {
        ctx.font = fontWeight + " " + fontSize + "px " + fontFamily;
        ctx.setFontSize(fontSize);
    }
}
export function setGlobalAlpha(ctx, alpha) {
    if (!ctx.setGlobalAlpha) {
        ctx.globalAlpha = alpha;
    }
    else {
        ctx.setGlobalAlpha(alpha);
    }
}
export function setLineCap(ctx, lineCap) {
    if (!ctx.setLineCap) {
        ctx.lineCap = lineCap;
    }
    else {
        ctx.setLineCap(lineCap);
    }
}
export function setLineJoin(ctx, lineJoin) {
    if (!ctx.setLineJoin) {
        ctx.lineJoin = lineJoin;
    }
    else {
        ctx.setLineJoin(lineJoin);
    }
}
export function setMiterLimit(ctx, miterLimit) {
    if (!ctx.setMiterLimit) {
        ctx.miterLimit = miterLimit;
    }
    else {
        ctx.setMiterLimit(miterLimit);
    }
}
export function setShadow(ctx, offsetX, offsetY, blur, color) {
    if (!ctx.setShadow) {
        ctx.shadowColor = color;
        ctx.shadowBlur = blur;
        ctx.shadowOffsetX = offsetX;
        ctx.shadowOffsetY = offsetY;
    }
    else {
        ctx.setShadow(offsetX, offsetY, blur, color);
    }
}
export function setStrokeStyle(ctx, stroke) {
    if (!ctx.setStrokeStyle) {
        ctx.strokeStyle = stroke;
    }
    else {
        ctx.setStrokeStyle(stroke);
    }
}
export function setTextAlign(ctx, textAlign) {
    if (!ctx.setTextAlign) {
        ctx.textAlign = textAlign;
    }
    else {
        ctx.setTextAlign(textAlign);
    }
}
export function setTextBaseline(ctx, textBaseline) {
    if (!ctx.setTextBaseline) {
        ctx.textBaseline = textBaseline;
    }
    else {
        ctx.setTextBaseline(textBaseline);
    }
}
